import { useCallback } from 'react'
import useScanDetection from 'use-scan-detection-react18'

interface BarcodeScannerConfig {
    handleAction: (code: string) => void
    handleError?: () => void
}
/**
 * ascii code input format is Alt49Alt50Alt51 = 123
 * So, the function will group the Alt[0-9] for detect the char and convert to the string
 */
const convertAsciiToText = (code: string) => {
    const regex = /Alt([0-9]{1,})/gm
    const matches = [...code.matchAll(regex)]
    if (matches.length > 0) {
        try {
            return matches
                ?.map((g) => String.fromCharCode(parseInt(g[1])))
                .join('')
        } catch {
            //prevent catch if can not convert to text
            return code
        }
    }
    return code
}
export default function useBarcodeScanner(config: BarcodeScannerConfig) {
    const onComplete = useCallback(
        (code: String) => {
            // Do not trigger the barcode scanning action when focused on any input or text area.
            if (
                document.activeElement?.nodeName === 'INPUT' ||
                document.activeElement?.nodeName === 'TEXTAREA'
            ) {
                return
            }

            // Remove focus from the current active element and focus on the document body.
            ;(document.activeElement as HTMLElement).blur()
            document.body.focus()

            let resCode = convertAsciiToText(code.valueOf())
            resCode = SanitizeCode(resCode)
            config.handleAction(resCode)

            function SanitizeCode(text: string) {
                text = text.replaceAll('Shift', '')
                text = text.replaceAll('Ctrl', '')
                text = text.replaceAll('Control', '')
                text = text.replaceAll('Alt', '')
                text = text.replaceAll('Meta', '')
                text = text.replaceAll('Insert', '')
                text = text.replaceAll('Delete', '')
                text = text.replaceAll('Home', '')
                text = text.replaceAll('End', '')
                text = text.replaceAll('PageUp', '')
                text = text.replaceAll('PageDown', '')
                text = text.replaceAll('Backspace', '')
                text = text.replaceAll('CapsLock', '')
                text = text.replaceAll('NumLock', '')
                text = text.replaceAll('ArrowUp', '')
                text = text.replaceAll('ArrowDown', '')
                text = text.replaceAll('ArrowLeft', '')
                text = text.replaceAll('ArrowRight', '')
                text = text.trim()
                return text
            }
        },
        [config],
    )

    const onError = useCallback(
        (err: String) => {
            console.error(err)
            config.handleError?.()
        },
        [config],
    )

    useScanDetection({
        minLength: 3,
        endCharacter: [
            9, // HT - Horizontal Tab
            10, // LF - Line Feed
            11, // VT - Vertical Tab
            13, // CR - Carriage Return
            27, // ESC - Escape Character
        ],
        onComplete: onComplete,
        onError: onError,
    })
}
